<template>
    <div>
        
            <ul class="nav nav-tabs" id="myTab" role="tablist" v-if="customProjectIdCheck">
                <li class="nav-item">
                    <a class="nav-link active" style="padding: 10px;" id="settings-tab" data-toggle="tab" href="#settings" role="tab" aria-controls="settings" aria-selected="true">Settings</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" style="padding: 10px;" id="editcustomprojectid-tab" data-toggle="tab" href="#editcustomprojectid" role="tab" aria-controls="editcustomprojectid" aria-selected="false">Edit Custom Project ID</a>
                </li>
            </ul>
            <div class="tab-content">

                <div class="tab-pane fade show active" id="settings" role="tabpanel" aria-labelledby="settings-tab">
                    
                    <div class="text-grey-darkest bg-white shadow-md rounded  mt-12 ml-20 border-1">
                        <div class="card m-0">
                            <div class="card-header">
                                    <p class="inline-block" style="margin-left: 10px">   Custom Project ID</p>
                                <span class="pull-right">
                                    <label for="customButtonSwitch" class="inline-block">OFF</label>
                                    <b-form-checkbox @change="customProjectIdSwitchUpdate" name="check-button" v-model="customProjectIdCheck" id="customButtonSwitch" class="inline-block" style="margin-left:10px !important" switch>
                                    </b-form-checkbox>
                                    <label for="customButtonSwitch" class="inline-block">ON</label>
                                    </span>
                            </div>
                            <div class="card-body">
                                <form>
                                    <draggable
                                        draggable=".item"
                                        :element="'ul'"
                                        handle=".handle"
                                        :list="options"
                                        @start="drag = true"
                                        @end="drag = false">
                                        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                            <li class="item"
                                                v-for="(column, index) in options"
                                                draggable='true'
                                                :key="column.id">
                                                <i class="fa fa-align-justify handle"></i>
                                                <b-form-checkbox @change="changeCheck(column.id)" :disabled="column.id == 'system_generated'"
                                                                 v-model="column.value"
                                                >
                                                    {{ column.label }}
                                                </b-form-checkbox>
                                                <ul>
                                                    <div v-if="column.input_type === 1">
                                                        <li>
                                                            <b-form-checkbox :class="column.sequential_class"
                                                                             v-model="column.sequential" :disabled="column.sequential"
                                                                             @change="changeState(column.sequential_class,column.id)"
                                                            >Sequential
                                                            </b-form-checkbox>
                                                        </li>
                                                        <li>
                                                            <div class="form-check form-inline" style="padding: 0px;">
                                                                <b-form-checkbox :class="column.start_from_class" :disabled="column.start_from"
                                                                                 @change="changeState(column.start_from_class,column.id)"
                                                                                 v-model="column.start_from"
                                                                >Start From #
                                                                </b-form-checkbox>
                                                                <span class="ml-2" style="width: 200px">
                                                                    <div v-if="column.id === 'year'">
                                                                        <b-form-input size="sm" v-model="column.input_value"
                                                                                      type="number" placeholder="2000"
                                                                                      :disabled="column.condition"
                                                                                      style="width: 90% !important;"></b-form-input>
                                                                    </div>
                                                                    <div v-else-if="column.id === 'month'">
                                                                        <b-form-input size="sm" v-model="column.input_value"
                                                                                      type="number" min="1" max="12"
                                                                                      placeholder="12" :disabled="column.condition"
                                                                                      style="width: 90% !important;"></b-form-input>
                                                                    </div>
                                                                    <div v-else-if="column.id === 'day'">
                                                                        <b-form-input size="sm" v-model="column.input_value"
                                                                                      type="number" min="1" max="31"
                                                                                      placeholder="31" :disabled="column.condition"
                                                                                      style="width: 90% !important;"></b-form-input>
                                                                    </div>
                                                                    <div v-else-if="column.id === 'system_generated'">
                                                                        <b-form-input size="sm" v-model="column.input_value"
                                                                                      type="number" placeholder="1000"
                                                                                      :disabled="column.condition"
                                                                                      style="width: 90% !important;"></b-form-input>
                                                                    </div>
                                                            </span>
                                                            </div>
                                                        </li>
                                                    </div>
                                                    <div v-else>
                                                        <li>
                                                            <b-form-checkbox :class="column.sequential_class" :disabled="column.disable"
                                                                             v-model="column.seperated_by_dash"
                                                                             @change="changeState(column.sequential_class,column.id)"
                                                            >Seperated by Dash
                                                            </b-form-checkbox>
                                                        </li>
                                                        <li>
                                                            <b-form-checkbox :class="column.start_from_class"
                                                                             v-model="column.seperated_by_space" :disabled="column.disable"
                                                                             @change="changeState(column.start_from_class,column.id)"
                                                            >Seperated by Space
                                                            </b-form-checkbox>
                                                        </li>
                                                    </div>
                                                </ul>
                                            </li>
                                        </transition-group>
                                    </draggable>
                                </form>
            
                            </div>
                            <div class="card-footer">
                                <span>{{ this.customProjectId }}</span>
                                <br>
                                <br>
                                <span v-if="team.foundation_db_connection_detail && customIdDigitLimitAllow()" class="text-danger">Note: If you want the the Custom Project ID to be synced as the Job # on Foundation, please make sure this does not exceed 10 digits/characters</span>
                            </div>
                        </div>
            
                    </div>
                    
                </div>
                <div class="tab-pane fade show" id="editcustomprojectid" role="tabpanel" aria-labelledby="editcustomprojectid-tab">
                    <custom-project-id-index 
                    :company-exists="true"
                    :user-legacy="true" 
                    :masks="{'date_mask':'MM\/dd\/yyyy','date_time_mask':'MM\/d\/yyyy hh:mm a','carbon_date_mask':'m\/d\/Y','moment_mask':'MM\/DD\/YYYY','v_mask_phone':['(###) ###-####','(###) ###-#### ext. #####'],'full_date_time_mask':'MM\/DD\/yyyy hh:mm A'}" 
                    :state="[]" 
                    :available-columns="available_columns" 
                    :available-sort="available_sort" 
                    :user-role="'owner'" 
                    :calendar="1"
                    :symbols="{'money':'$','currency_name':'Dollars','DDI':'+1'}" 
                    :exchange="false" 
                    :can-delete="true" 
                    :field-labels="{'marketing-status':'Marketing Status','pre-bid':'Pre Bid','bid-date':'Bid Date','estimator':'Estimator','account-manager':'Account Manager','take-off-person':'Take Off Person','sales-status':'Sales Status','lead-source':'Lead Source1','products-and-services':'Products &amp; Services','client-profile':'Client Profile','office':'Office','contract-type':'Contract Type'}" 
                    :has-bulk-email-access="1" 
                    :user-item-per-page="{'company': 15, 'contact': 50, 'project': 15}">
                    </custom-project-id-index>
                </div>
            </div>

          
        
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Form from "../../../utils/form";
import draggable from 'vuedraggable';
import Swal from "sweetalert2";
import {projectColumnListForCustomProjectSetting} from "../../../constants";

export default {
    name: 'custom-project-id',
    props: {
        customProjectIdState: {
            type: Array,
        },
        team:{},
    },
    data() {
        let customIDState = this.customProjectIdState
        let newState = [
            {
                "label": "Year",
                "id": "year",
                "value": true,
                "disable": false,
                "sequential": true,
                "start_from": false,
                "sequential_class": "sequential_year",
                "start_from_class": "start_from_year",
                "condition": true,
                "input_value": 2022,
                "input_type": 1,
            },
            {
                "label": "Month",
                "id": "month",
                "value": true,
                "disable": false,
                "sequential": true,
                "start_from": false,
                "sequential_class": "sequential_month",
                "start_from_class": "start_from_month",
                "condition": true,
                "input_value": 8,
                "input_type": 1,
            },
            {
                "label": "Day",
                "id": "day",
                "value": true,
                "disable": false,
                "sequential": true,
                "start_from": false,
                "sequential_class": "sequential_day",
                "start_from_class": "start_from_day",
                "condition": true,
                "input_value": 21,
                "input_type": 1,
            },
            {
                "label": "System Generated",
                "id": "system_generated",
                "value": true,
                "disable": false,
                "sequential": true,
                "start_from": false,
                "sequential_class": "sequential_system_generated",
                "start_from_class": "start_from_system_generated",
                "condition": true,
                "input_value": 1000,
                "input_type": 1,
            },
            {
                "label": "Other",
                "id": "other",
                "value": true,
                "disable": false,
                "sequential_class": "sequential_other",
                "start_from_class": "start_from_other",
                "condition": true,
                "seperated_by_dash": true,
                "seperated_by_space": false,
                "input_type": 0,
            }
        ];
        if (customIDState) {
            const stateHash = customIDState.reduce(function (map, obj) {
                if(obj.id == "system_generated"){
                    obj.value = true;
                }
                map[obj.id] = obj;
                return map;
            }, {});
            newState = Object.values(stateHash);
        } else {
            const baseStateHash = newState.reduce(function (map, obj) {
                if(obj.id == "system_generated"){
                    obj.value = true;
                }
                map[obj.id] = obj;
                return map;
            }, {});
            newState = Object.values(baseStateHash);
        }
        return {
            drag: false,
            options: newState,
            customProjectId: '',
            'customProjectIdCheck': (this.team.custom_project_id_check == 1) ? true : false,
            available_columns: projectColumnListForCustomProjectSetting,
            available_sort: { 'sequential_team_id': 'sequential_team_id', 'custom_project_id': 'custom_project_id', 'base_bid': 'base_bid', 'sales_statuses_code': 'sales_statuses_code', 'marketing_status': 'marketing_status','legacy_id': 'legacy_id', 'name': 'name', 'address': 'address', 'city': 'city', 'state': 'state', 'zip': 'zip', 'contact_name': 'contact_name', 'contact_email': 'contact_email', 'contact_cell': 'contact_cell', 'contact_phone': 'contact_phone'}
        };
    },
    components: {
        draggable
        // ,ProjectIndex
    },
    watch: {
        options: {
            handler: function (val, oldVal) {
                this.perviewCustomId();
                this.saveState();
            },
            deep: true
        },
        customProjectId: {
            handler: function (val, oldVal) {
                this.customIdDigitLimitAllow();
            }
        }
    },
    created() {
        this.saveState();
        this.perviewCustomId();
        this.customIdDigitLimitAllow();
    },
    methods: {
        changeCheck(idName) {
            let newState = this.options;
            const optionsCopy = [...newState];
            const targetIndex = newState.findIndex(f => f.id === idName);
            if (idName == "year" && newState[targetIndex].value == true && newState[targetIndex].input_type == 1){
                newState[targetIndex].disable = true;
                if (idName == "year" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
                if (idName == "year" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
            }
            if (idName == "year" && newState[targetIndex].value == false && newState[targetIndex].input_type == 1){
                newState[targetIndex].disable = false;
                if (idName == "year" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
                if (idName == "year" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = false;
                }
            }
            if (idName == "month" && newState[targetIndex].value == true && newState[targetIndex].input_type == 1){
                newState[targetIndex].disable = true;
                if (idName == "month" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
                if (idName == "month" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
            }
            if (idName == "month" && newState[targetIndex].value == false && newState[targetIndex].input_type == 1){
                newState[targetIndex].disable = false;
                if (idName == "month" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
                if (idName == "month" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = false;
                }
            }
            if (idName == "day" && newState[targetIndex].value == true && newState[targetIndex].input_type == 1){
                newState[targetIndex].disable = true;
                if (idName == "day" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
                if (idName == "day" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
            }
            if (idName == "day" && newState[targetIndex].value == false && newState[targetIndex].input_type == 1){
                newState[targetIndex].disable = false;
                if (idName == "day" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
                if (idName == "day" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = false;
                }
            }
            if (idName == "system_generated" && newState[targetIndex].value == true && newState[targetIndex].input_type == 1){
                newState[targetIndex].disable = true;
                if (idName == "system_generated" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
                if (idName == "system_generated" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
            }
            if (idName == "system_generated" && newState[targetIndex].value == false && newState[targetIndex].input_type == 1){
                newState[targetIndex].disable = false;
                if (idName == "system_generated" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = true;
                }
                if (idName == "system_generated" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].condition = false;
                }
            }
            if (idName == "other" && newState[targetIndex].value == true && newState[targetIndex].input_type == 0){
                newState[targetIndex].disable = true;
            }
            if (idName == "other" && newState[targetIndex].value == false && newState[targetIndex].input_type == 0){
                newState[targetIndex].disable = false;
            }
        },

        changeState(className, idName) {
            let newState = this.options;
            const optionsCopy = [...newState];
            const targetIndex = newState.findIndex(f => f.id === idName);

            if (className == 'start_from_' + newState[targetIndex].id && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                newState[targetIndex].sequential = false;
                newState[targetIndex].start_from = true;
                newState[targetIndex].condition = false;
            }
            if (className == 'sequential_' + newState[targetIndex].id && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                newState[targetIndex].sequential = true;
                newState[targetIndex].start_from = false;
                newState[targetIndex].condition = true;
            }
            if (className == 'start_from_' + newState[targetIndex].id && newState[targetIndex].seperated_by_dash == true && newState[targetIndex].input_type == 0) {
                newState[targetIndex].seperated_by_dash = false;
                newState[targetIndex].seperated_by_space = true;
            }
            if (className == 'sequential_' + newState[targetIndex].id && newState[targetIndex].seperated_by_space == true && newState[targetIndex].input_type == 0) {
                newState[targetIndex].seperated_by_dash = true;
                newState[targetIndex].seperated_by_space = false;
            }
        },

        perviewCustomId() {
            let newState = this.options;
            const customId = [];
            var other = '';
            for (const element of newState) {
                switch (element.id) {
                    case 'year':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                let year = new Date().getFullYear();
                                customId.push(year);
                            } else if (element.start_from === true) {
                                let year = element.input_value;
                                customId.push(year);
                            }
                        }
                        break;
                    case 'month':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                let month = new Date().getMonth() + 1;
                                customId.push(month);
                            } else if (element.start_from === true) {
                                let month = element.input_value;
                                customId.push(month);
                            }
                        }
                        break;
                    case 'day':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                let day = new Date().getDate();
                                customId.push(day);
                            } else if (element.start_from === true) {
                                let day = element.input_value;
                                customId.push(day);
                            }
                        }
                        break;
                    case 'system_generated':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                let system_generated = Math.floor(element.input_value);
                                customId.push(system_generated);
                            } else if (element.start_from === true) {
                                let system_generated = element.input_value;
                                customId.push(system_generated);
                            }
                        }
                        break;
                    case 'other':
                        if (element.value === true) {
                            if (element.seperated_by_dash === true) {
                                var other = '-';
                            } else if (element.seperated_by_space === true) {
                                var other = '/';
                            } else {
                                var other = '';
                            }
                        } else {
                            var other = '';
                        }
                        break;
                }
            }
            if (other == '-') {
                var idProject = customId.join("-");
            }
            if (other == '/') {
                var idProject = customId.join(" ");
            }
            if (other == '') {
                var idProject = customId.join("");
            }
            this.customProjectId = idProject;
        },

        saveState() {
            let newState = this.options;
            axios.put(route('api.project_custom_id.state'), {state: newState})
                .then(response => {
                });
        },

        customProjectIdSwitchUpdate(){
            this.$nextTick(()=>{
                var data = {
                    'access': (this.customProjectIdCheck)? 1:0
            };
                axios.post(route('api.project_custom_id.check'), data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        })
                    }
                );
            });
        },
        customIdDigitLimitAllow() {
            // return (this.customProjectId.replace(/\D/g, '')).length > 10;
            return this.customProjectId.length > 10;
        }
    },


}
</script>

<style>
ul {
    list-style-type: none;
}

.form-control-sm {
    width: inherit !important;
}

.custom-control {
    margin-left: 20px !important;
    display: inline-block !important;
}
</style>


